<template>
  <v-app>
    <v-container fluid fill-height class="darkbg">
      <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="6"
            md="4"
            align="center"
          >
            <img :src="images.logo" width="150"/>
            <v-card
              v-if="reset_token_valid == false"
              class="elevation-12"
              light
            >
              <v-card-title class="pb-0">
                Password reset
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  fill-height
                  justify-center
                  align-center
                  v-if="loading"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>

                <v-form
                  v-else
                  ref="form"
                  v-model="valid"
                >
                  Enter your email address below, and we'll email instructions for setting a new one.
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    prepend-inner-icon="mdi-email"
                    label="Email"
                    color="primary"
                    autocomplete="email"
                    :disabled="disable_email"
                    autofocus
                    required
                  ></v-text-field>

                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                <v-btn
                  :disabled="!valid || disable_email"
                  color="primary"
                  @click="validate"
                  block
                  >
                  <v-icon left>mdi-lock</v-icon>
                  Reset
                </v-btn>
              </v-card-actions>
              <v-divider></v-divider>
              <v-card-text v-if="showDoneMessage">
                {{doneMessage}}
              </v-card-text>
            </v-card>
            <v-card
              v-if="reset_token_valid == true"
              class="elevation-12"
              light
            >
              <v-card-title class="pb-0">
                Password reset confirm
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout
                  row
                  fill-height
                  justify-center
                  align-center
                  v-if="loading"
                >
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>

                <v-form
                  v-else
                  ref="form_confirm"
                  v-model="valid_fnew"
                >
                  Enter your new password
                  <v-text-field
                    v-model="new_password1"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="passwordRules"
                    color="primary"
                    maxlength="128"
                    autocomplete="current-password"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="new_password2"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password (Again)"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :rules="passwordRules"
                    color="primary"
                    maxlength="128"
                    autocomplete="current-password"
                    required
                  ></v-text-field>

                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                <v-btn
                  :disabled="!valid_fnew"
                  color="primary"
                  @click="checkResetTokenChange"
                  block
                  >
                  <v-icon left>mdi-lock</v-icon>
                  Update password
                </v-btn>
              </v-card-actions>
              <v-divider></v-divider>
              <v-card-text v-if="showDoneMessage">
                {{doneMessage}}
              </v-card-text>
            </v-card>
            <v-spacer></v-spacer>

            <v-btn class="text-left" text to="/"><v-icon left dark>mdi-arrow-left</v-icon>Back to Home</v-btn>
          </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      <span v-html="snackText"></span>
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-footer>

    <v-spacer></v-spacer>
    <div class="caption">&copy; {{ new Date().getFullYear() }} - Patrowl.io</div>
   </v-footer>
  </v-app>
</template>

<script>
// import axios from 'axios';
export default {
  name: 'AppLogin',
  data: () => ({
    valid: true,
    loading: false,
    disable_email: false,
    captcha_token: '',
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length > 8) || "The password must be longer than 8 characters",
      v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
      v => /(?=.*\d)/.test(v) || 'Must have one number',
      v => /([!@$%])/.test(v) || 'Must have one special character [!@#$%]'
    ],
    showDoneMessage: false,
    doneMessage: "",
    doneMessageOK: "We've emailed you instructions for setting your password. You should receive the email shortly!",
    doneMessageKO: "An error occurred during the reset process.",
    uid: '',
    token: '',
    reset_token_valid: false,
    valid_fnew: true,
    showPassword: false,
    new_password1: '',
    new_password2: '',
    images: {
      // logo: require('@/assets/img/logo-owl-text-large-white.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  beforeRouteUpdate(to) {
    this.uid = to.query.uid;
    this.token = to.query.token;
    this.checkResetToken();
  },
  mounted() {
    this.recaptcha();
    this.uid = this.$router.currentRoute.query.uid;
    this.token = this.$router.currentRoute.query.token;
    this.checkResetToken();
  },
  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
        this.captcha_token = await this.$recaptcha('login');
    },
    validate () {
      if (this.valid && this.captcha_token != '') {
        let formdata = {
          'email': this.email,
          'g-recaptcha-response': this.captcha_token,
        };
        // console.log(formdata)

        this.loading = true;
        this.$api.post('/api/public/users/reset', formdata).then(res => {
          if (res && res.status === 200) {
            this.showDoneMessage = true;
            this.doneMessage = this.doneMessageOK;
            // this.$router.push({name: 'PrivateHome'});
          } else {
            this.showDoneMessage = true;
            this.doneMessage = this.doneMessageKO;
          }
        }).catch(e => {
          console.log(e)
          this.showDoneMessage = true;
          this.doneMessage = this.doneMessageKO;
        });
        this.disable_email = true;
        this.loading = false;
      }
    },
    checkResetToken() {
      if (this.uid == undefined || this.uid === '' || this.token == undefined || this.token === '') {
        this.reset_token_valid = false;
        return;
      }
      this.reset_token_valid = true;


    },
    checkResetTokenChange() {
      if (this.reset_token_valid == false) return;

      let formdata = {
        'new_password1': this.new_password1,
        'new_password2': this.new_password2,
        'g-recaptcha-response': this.captcha_token,
      };

      this.$api.post('/api/public/users/reset-confirm/'+this.uid+"/"+this.token, formdata).then(res => {
        if (res && res.status === 200 && res.data.status === "ok") {
          // this.registration.email = res.data.email;
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Password successfuly renewed.';
          // this.$router.push('/login');
          setTimeout( () => this.$router.push('/login'), 3000);

        } else {
          // this.$router.push('/portal/home');
          this.snack = true;
          this.snackColor = 'error';
          this.snackText = res.data.message;
        }
      }).catch(e => {
        console.log(e);
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = "Unable to renew password. Link already used ?";
        // this.$router.push('/portal/home');
        // setTimeout( () => this.$router.push('/portal/login'), 5000);
      });
    }
  },
}
</script>
<style scoped>
  h1 {
    font-size: 150px;
    line-height: 150px;
    font-weight: 700;
    color: #252932;
    text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
  }
</style>
